import { RadioButtonList as UiRadioButtonList, styled, Typography } from "@l2r-front/l2r-ui"

export const RadioButtonList = styled(UiRadioButtonList)(({ theme }) => ({
    gap: theme.spacing(3),
    padding: theme.spacing(0, 5),
}))

export const Text = styled(Typography)({
    textAlign: "center",
})
